import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import { Button } from './button';
import { UploadCloud, File as FileIcon, X } from 'lucide-react';

interface FileUploadProps {
  onFileUpload: (file: File) => void;
  className?: string;
}

export const FileUpload: React.FC<FileUploadProps> = ({ onFileUpload, className }) => {
  const [file, setFile] = useState<File | null>(null);

  const onDrop = useCallback((acceptedFiles: File[]) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      const selectedFile = acceptedFiles[0];
      setFile(selectedFile);
      onFileUpload(selectedFile);
    }
  }, [onFileUpload]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: { 'text/csv': ['.csv'] },
    multiple: false,
  });

  const removeFile = () => {
    setFile(null);
  };

  return (
    <div className={className}>
      {file ? (
        <div className="flex items-center justify-between p-3 border rounded-md bg-secondary">
          <div className="flex items-center space-x-2">
            <FileIcon className="w-4 h-4 text-muted-foreground" />
            <span className="text-sm font-medium">{file.name}</span>
          </div>
          <Button variant="ghost" size="icon" onClick={removeFile}>
            <X className="w-4 h-4" />
          </Button>
        </div>
      ) : (
        <Button
          variant="outline"
          {...getRootProps()}
          className={`flex items-center space-x-2 cursor-pointer hover:bg-secondary transition-colors ${
            isDragActive ? 'border-primary bg-secondary' : ''
          }`}
        >
          <input {...getInputProps()} />
          <UploadCloud className="w-4 h-4" />
          <span>Upload CSV</span>
        </Button>
      )}
    </div>
  );
};
